// extracted by mini-css-extract-plugin
export default {"actions":"styles-module__actions__src-labstep-web-core-Modal-Confirmation-_vGRAy","warningHeader":"styles-module__warningHeader__src-labstep-web-core-Modal-Confirmation-_vhX9t"};